import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createHandleDocumentsUploadedThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.HandleDocumentsUploaded,
    async ({ applicationId }: { applicationId: string }) => {
      const response = await api.handleDocumentsUploaded(applicationId);
      return response;
    },
  );
